"use client";

import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { useDashboardData } from "../../../../hooks/useDashboardData";

const LeadsBySource = () => {
  const [Chart, setChart] = useState();
  const { topApps } = useDashboardData();

  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  // Take top 5 apps/websites and map to the format needed
  const top5Apps = useMemo(() => {
    if (!topApps || topApps.length === 0) {
      return [
        { name: "Slack", value: 320 },
        { name: "VS Code", value: 160 },
        { name: "Figma", value: 279 },
        { name: "Chrome", value: 60 },
        { name: "Teams", value: 30 },
        { name: "Others", value: 19 }
      ];
    }
    
    return topApps.slice(0, 6).map(app => ({
      name: app.name,
      value: Math.round(app.value)
    }));
  }, [topApps]);

  const series = top5Apps.map(a => a.value);
  const labels = top5Apps.map(a => a.name);

  // Map colors to match the original design
  const colors = ["#605DFF", "#3584FC", "#AD63F6", "#0dcaf0", "#27e18aaf", "#FD5812"];

  const options = {
    labels,
    colors,
    stroke: {
      width: 1,
      show: true,
      colors: ["#ffffff"],
    },
    legend: {
      show: false,
      position: "top",
      fontSize: "12px",
      horizontalAlign: "center",
      itemMargin: {
        horizontal: 8,
        vertical: 0,
      },
      labels: {
        colors: "#64748B",
      },
      markers: {
        shape: 'diamond',
        width: 9,
        height: 9,
        offsetX: -2,
        offsetY: -0.5,
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          labels: {
            show: true,
            name: {
              color: "#64748B",
            },
            value: {
              show: true,
              color: "#3A4252",
              fontSize: "28px",
              fontWeight: "600",
            },
            total: {
              show: true,
              label: "Total",
              color: "#64748B",
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
  };

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30">
            <h3 className="mb-0">Top Apps & Websites</h3>
          </div>

          <div
            style={{ 
              marginTop: "-10px",
            }}
            className="t-chart"
          >
            {Chart && series.length > 0 && (
              <Chart
                options={options}
                series={series}
                type="donut"
                height={245}
              />
            )}
          </div>

          <Row className="">
            {top5Apps.map((app, index) => (
              <Col key={index} xs={12} md={2} lg={4} className="col mt-3">
                <div className="d-flex align-items-center">
                  <span 
                    className="wh-11 rounded-1 me-1"
                    style={{ 
                      backgroundColor: colors[index % colors.length] 
                    }}
                  ></span>
                  <span>{app.name}</span>
                </div>
                <h4 className="fs-15 fw-medium mb-0 mt-1">{app.value} hrs</h4>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default LeadsBySource;